import { render, staticRenderFns } from "./MoleculeContractDetailsContainer.vue?vue&type=template&id=6e413ec9&"
import script from "./MoleculeContractDetailsContainer.vue?vue&type=script&lang=js&"
export * from "./MoleculeContractDetailsContainer.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContractDetailsContainer.vue?vue&type=style&index=0&id=6e413ec9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/OrganismAvailabilityDrawer.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculeContractDetailsContainer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports